export default __webpack_public_path__ + "static/media/logo-bank-14.2d57eaf9.png";